import * as React from 'react';
import { SVGAttributes } from 'react';

export const GcpOutlineIcon = ({ color, ...rest }: SVGAttributes<SVGElement>) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.38127 9.51861C1.87291 10.0272 1.87291 10.8505 2.38127 11.3591L4.63941 13.6184C5.14799 14.1272 5.97152 14.1272 6.4801 13.6184L7.9974 12.1003L9.5147 13.6184C9.77787 13.8817 10.1129 13.9987 10.4376 13.9987C10.7804 13.9987 11.1017 13.8648 11.3462 13.6324L11.3535 13.6255L13.6187 11.3591C14.1271 10.8505 14.1271 10.0272 13.6187 9.51861L12.0964 7.99931L13.6135 6.48139C14.1219 5.97277 14.1219 5.14951 13.6135 4.64089L11.3554 2.38162C10.8468 1.87279 10.0233 1.87279 9.5147 2.38162L7.9974 3.89968L6.47301 2.37453L6.46573 2.36762C6.22118 2.13517 5.89986 2.0013 5.55715 2.0013C5.22715 2.0013 4.89041 2.1305 4.63941 2.38162L2.38127 4.64089C1.87291 5.14951 1.87291 5.97277 2.38127 6.48139L3.89913 8L2.38127 9.51861ZM5.91304 8.00288L8.00288 10.087L10.087 7.99712L8.00288 5.91304L5.91304 8.00288Z"
        stroke={color}
      />
    </svg>
  );
};
